module.exports = __webpack_public_path__ + "img/20191119163742360截图20191119162847086.5c30015a.jpg";